import React, { useState } from "react";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { makeStyles } from "@material-ui/core/styles";
import stethoscope from "../../images/stethoscope.svg";
import useUserState from "../hooks/useUserState";
import Axios from "axios";
import HealthMeasurementDialog from "./HealthMeasurementDialog";
import useBDocTranslator from "../hooks/useBDocTranslator";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    boxShadow: theme.shadows[8],
    padding: theme.spacing(4),
    width: "90%",
    maxWidth: 720,
    maxHeight: "90vh",
    overflowY: "auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    "& img": {
      width: 32,
      height: 32,
      marginRight: theme.spacing(1.5),
    },
    "& h3": {
      margin: 0,
      fontSize: "1.125rem",
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
  },
}));

export default function HealthMeasurementModalForm(props) {
  const classes = useStyles();
  const [responseMessage, setResponseMessage] = useState("");
  const userLocalState = useUserState();
  const [successFlag, setSuccessFlag] = useState(false);
  const { t } = useBDocTranslator();

  //Method creates a new health measurement record in the database
  const handleMeasureCreate = async (data, refresh) => {
    if (!validateData(data)) {
      setResponseMessage("Error, Please fill the Form");
      return;
    }

    if (props.editValue && data.measurement_type === "ECG") {
      await Axios.put(
        `${process.env.REACT_APP_API_URL_BASE}/measurement/edit`,
        {
          id: props.editValue?.id,
          result: data.result,
        },
        {
          headers: { Authorization: "Bearer " + userLocalState[0].jwt },
        }
      )
        .then((res) => {
          setSuccessFlag(true);
          props.handleRefreshData(props.patientId);
        })
        .catch((error) => {
          console.log(error);
          setResponseMessage("Error " + error);
        });
      return;
    }

    await Axios.post(
      `${process.env.REACT_APP_API_URL_BASE}/measurement/create`,
      data,
      {
        headers: { Authorization: "Bearer " + userLocalState[0].jwt },
      }
    )
      .then((res) => {
        setSuccessFlag(true);
        setResponseMessage(
          "Measurement created, record is going to be displayed in the App"
        );
        if (refresh) {
          props.handleRefreshData(props.patientId);
        }
      })
      .catch((error) => {
        console.log(error);
        setResponseMessage("Error " + error);
      });
  };

  // validate the data object if it is valid
  function validateData(data) {
    let isValid = false;
    if (data.measurement_type !== "" && data.result !== "") {
      isValid = true;
    }
    return isValid;
  }

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        // className="flex items-center justify-center overflow-y-auto"
        open={props.open}
        onClose={() => {
          props.handleClose();
          setResponseMessage("");
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={props.open}>
          {
            <div className={classes.paper}>
              <div className={classes.header}>
                <img src={stethoscope} alt="health monitor icon" />
                <h3>{t("Monitor")}</h3>
              </div>
              {responseMessage && (
                <p
                  className={`font-weight-bold text-center ${
                    responseMessage.includes("Error") ? "text-danger" : "text-success"
                  }`}
                  style={{ marginBottom: "12px" }}
                >
                  {t(responseMessage)}
                </p>
              )}
              {/* Form */}
              <div>
                <HealthMeasurementDialog
                  handleMeasureCreate={handleMeasureCreate}
                  handleClose={() => {
                    props.handleClose();
                    setResponseMessage("");
                  }}
                  appointmentFiles={props.appointmentFiles}
                  successFlag={successFlag}
                  type={props.type}
                  patientId={props.patientId}
                  resetResponseMsg={() => setResponseMessage("")}
                  editValue={props.editValue}
                  setEditValue={props.setEditValue}
                />
              </div>
            </div>
          }
        </Fade>
      </Modal>
    </div>
  );
}
